import React, { useEffect } from 'react';
import { useProductContext } from '../../../extensible/product-router';
import { onShown, type OnShownProps } from '../events';
import { withAnalytics } from '../with-analytics';
import { useShowAtlassianHomeSearchLink } from '../../show-atlassian-home-search-link';

interface Props {
	isExpanded: boolean;
	onDialogShown: (props: OnShownProps) => any;
}

export const DialogShownHandlerComponent: React.FC<Props> = ({ isExpanded, onDialogShown }) => {
	const { products, getPrimaryProduct } = useProductContext();
	const primaryProduct = getPrimaryProduct();
	const isRovoCrossProductSearchLinkShown = useShowAtlassianHomeSearchLink(primaryProduct?.id);

	useEffect(() => {
		const emitAnalyticsEvent = () => {
			const visibleProducts = products.map((product) => product.title);
			const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
			onDialogShown({ visibleProducts, visibleTabsCount, isRovoCrossProductSearchLinkShown });
		};

		isExpanded && emitAnalyticsEvent();
	}, [isExpanded]); // eslint-disable-line react-hooks/exhaustive-deps

	return <></>;
};

export const DialogShownHandler = withAnalytics({
	onDialogShown: onShown,
})(DialogShownHandlerComponent);
